import SeriesAttendancePolicy from '@/components/Series/SeriesAttendancePolicy'
import type {
  FormBlock,
  FormErrors,
  FormInputType,
  FormOnValidate,
  FormValues,
} from '@/components/UI/Form/types'

import getAutoJoinWorldFormInput from './getAutoJoinWorldFormInput'

const ATTENDANCE_POLICY_CONFIRM = 'I understand'
const ATTENDANCE_POLICY_ERROR_MESSAGE = `Please type "${ATTENDANCE_POLICY_CONFIRM}" exactly to confirm the attendance policy.`

export function getSeriesRegistrationOnValidate(): FormOnValidate {
  const onValidate: FormOnValidate = (values: FormValues, _errors: FormErrors | null) => {
    if (
      !(
        `${values.attendance_policy_text}`.toLowerCase().trim() ===
        ATTENDANCE_POLICY_CONFIRM.toLowerCase()
      )
    ) {
      return {
        errors: { attendance_policy_text: ATTENDANCE_POLICY_ERROR_MESSAGE },
        message: ATTENDANCE_POLICY_ERROR_MESSAGE,
      }
    }
    return null
  }
  return onValidate
}

export default function getSeriesRegistrationFormBlocks({
  attendancePolicy,
  seriesQuestionnaire,
  worldTitleToRegisterFor,
  hasRequiredAttendanceSessions,
  isSATBootcamp,
  includeSmsUpsell = false,
}: {
  attendancePolicy: string
  seriesQuestionnaire: FormInputType[] | null
  worldTitleToRegisterFor: string | null
  hasRequiredAttendanceSessions: boolean
  isSATBootcamp: boolean
  includeSmsUpsell?: boolean
}): FormBlock[] {
  const attendancePolicyFormBlocks: FormBlock[] = [
    {
      type: 'content',
      name: 'attendance_policy',
      display: 'display',
      content: (
        <SeriesAttendancePolicy
          attendancePolicy={attendancePolicy}
          hasRequiredAttendanceSessions={hasRequiredAttendanceSessions}
          isSATBootcamp={isSATBootcamp}
        />
      ),
      size: 6,
    },
    ...(includeSmsUpsell
      ? ([
          {
            type: 'multi-checkbox',
            name: 'enable-text',
            label: 'Enable text notifications?',
            options: [
              {
                label:
                  'I would like to receive text message reminders prior to my session starting',
                value: 'yes',
              },
            ],
            required: false,
            size: 6,
          },
        ] satisfies FormBlock[])
      : []),
    {
      type: 'text',
      name: 'attendance_policy_text',
      label: `Please type "${ATTENDANCE_POLICY_CONFIRM}" to acknowledge the above attendance policy.`,
      required: true,
      placeholder: ATTENDANCE_POLICY_CONFIRM,
      size: 6,
    },
  ]

  const registerForWorldInput: FormBlock | null =
    worldTitleToRegisterFor != null
      ? getAutoJoinWorldFormInput({
          worldTitleToRegisterFor,
          sessionOrSeries: 'series',
        })
      : null

  return [
    ...(seriesQuestionnaire ?? []),
    ...attendancePolicyFormBlocks,
    ...(registerForWorldInput != null ? [registerForWorldInput] : []),
  ]
}
